/**
 * Haptic feedback utility.
 * Falls back gracefully on devices that don't support the Vibration API.
 */

export function hapticTap() {
  if (navigator.vibrate) navigator.vibrate(10);
}

export function hapticSuccess() {
  if (navigator.vibrate) navigator.vibrate([10, 50, 10]);
}

export function hapticError() {
  if (navigator.vibrate) navigator.vibrate([50, 30, 50, 30, 50]);
}
